// extracted by mini-css-extract-plugin
export default {"wrap":"TF-z","articleImagesWrap":"UF-z","articleImage":"VF-z","singleImage":"WF-z"};